import axios from 'axios';
import { jwtDecode } from 'jwt-decode'; // Corrected import
import router from '@/router'; // Import Vue Router

// Single-flight refresh: semua request paralel yang menemukan token expired
// berbagi SATU promise refresh yang sama, sehingga hanya ada 1 request
// /api/token/refresh/ (bukan 1 per request).
let refreshPromise = null;
// Redirect ke /login hanya sekali (bukan sekali per request yang gagal).
let redirectedToLogin = false;

async function refreshAccessToken() {
    const refreshToken = localStorage.getItem('refresh_token');
    const refreshResponse = await axios.post(
        `${process.env.VUE_APP_API_BASE_URL}/api/token/refresh/`,
        { refresh: refreshToken },
        { _retry: true } // ← bypass interceptor di request refresh
    );
    localStorage.setItem('token', refreshResponse.data.access);
    return refreshResponse.data.access;
}

function clearAuthAndRedirect() {
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');
    if (!redirectedToLogin) {
        redirectedToLogin = true;
        router.push('/login');
    }
}

const axiosPlugin = {
    install: (app) => {
        axios.interceptors.request.use(
            async (config) => {
                // Bypass semua logika auth untuk request refresh itu sendiri.
                // Tanpa ini, refresh request ikut lewat interceptor → token masih
                // expired → refresh lagi → rekursi tak terbatas → halaman hang selamanya.
                if (config._retry) {
                    return config;
                }

                const token = localStorage.getItem('token');
                if (token) {
                    let isExpired = true;
                    try {
                        const decodedToken = jwtDecode(token);
                        isExpired = decodedToken.exp * 1000 < Date.now();
                    } catch (e) {
                        // Token tidak valid (rusak) — bersihkan dan lanjutkan tanpa auth.
                        // Sebelumnya jwtDecode throw → semua request gagal/hang.
                        console.error('Invalid token, clearing:', e);
                        localStorage.removeItem('token');
                        localStorage.removeItem('refresh_token');
                        return config;
                    }

                    if (isExpired) {
                        try {
                            if (!localStorage.getItem('refresh_token')) {
                                // Tidak ada refresh token — jangan hang, biarkan request
                                // lanjut tanpa auth (nanti 401 di-handle response).
                                localStorage.removeItem('token');
                                return config;
                            }

                            // Single-flight: pakai promise refresh yang sedang berjalan
                            // jika ada, atau mulai yang baru. Saat selesai, semua
                            // request yang menunggu lanjut dengan token baru.
                            if (!refreshPromise) {
                                refreshPromise = refreshAccessToken().finally(() => {
                                    refreshPromise = null;
                                });
                            }
                            const newAccessToken = await refreshPromise;
                            config.headers.Authorization = `Bearer ${newAccessToken}`;
                        } catch (refreshError) {
                            console.error('Token refresh failed:', refreshError);
                            clearAuthAndRedirect();
                            return Promise.reject(refreshError);
                        }
                    } else {
                        config.headers.Authorization = `Bearer ${token}`;
                    }
                }
                return config;
            },
            (error) => {
                return Promise.reject(error);
            }
        );

        // Optionally, you can make axios available globally:
        app.config.globalProperties.$axios = axios;  // Access as this.$axios in components
    }
};

export default axiosPlugin;
